import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  type: "function",
  name: "owners",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256"
  }],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "removeOwner",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "owner"
  }],
  outputs: []
}, {
  type: "function",
  name: "revokeConfirmation",
  constant: false,
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: []
}, {
  type: "function",
  name: "isOwner",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "address"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "confirmations",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256"
  }, {
    type: "address"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "getTransactionCount",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bool",
    name: "pending"
  }, {
    type: "bool",
    name: "executed"
  }],
  outputs: [{
    type: "uint256",
    name: "count"
  }]
}, {
  type: "function",
  name: "addOwner",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "owner"
  }],
  outputs: []
}, {
  type: "function",
  name: "isConfirmed",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "getConfirmationCount",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: [{
    type: "uint256",
    name: "count"
  }]
}, {
  type: "function",
  name: "transactions",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256"
  }],
  outputs: [{
    type: "address",
    name: "destination"
  }, {
    type: "uint256",
    name: "value"
  }, {
    type: "bytes",
    name: "data"
  }, {
    type: "bool",
    name: "executed"
  }]
}, {
  type: "function",
  name: "getOwners",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address[]"
  }]
}, {
  type: "function",
  name: "getTransactionIds",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256",
    name: "from"
  }, {
    type: "uint256",
    name: "to"
  }, {
    type: "bool",
    name: "pending"
  }, {
    type: "bool",
    name: "executed"
  }],
  outputs: [{
    type: "uint256[]",
    name: "_transactionIds"
  }]
}, {
  type: "function",
  name: "getConfirmations",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: [{
    type: "address[]",
    name: "_confirmations"
  }]
}, {
  type: "function",
  name: "transactionCount",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "changeRequirement",
  constant: false,
  payable: false,
  inputs: [{
    type: "uint256",
    name: "_required"
  }],
  outputs: []
}, {
  type: "function",
  name: "confirmTransaction",
  constant: false,
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: []
}, {
  type: "function",
  name: "submitTransaction",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "destination"
  }, {
    type: "uint256",
    name: "value"
  }, {
    type: "bytes",
    name: "data"
  }],
  outputs: [{
    type: "uint256",
    name: "transactionId"
  }]
}, {
  type: "function",
  name: "MAX_OWNER_COUNT",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "required",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "uint256"
  }]
}, {
  type: "function",
  name: "replaceOwner",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "owner"
  }, {
    type: "address",
    name: "newOwner"
  }],
  outputs: []
}, {
  type: "function",
  name: "executeTransaction",
  constant: false,
  payable: false,
  inputs: [{
    type: "uint256",
    name: "transactionId"
  }],
  outputs: []
}, {
  type: "constructor",
  payable: false,
  inputs: [{
    type: "address[]",
    name: "_owners"
  }, {
    type: "uint256",
    name: "_required"
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Confirmation",
  inputs: [{
    type: "address",
    name: "sender",
    indexed: true
  }, {
    type: "uint256",
    name: "transactionId",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Revocation",
  inputs: [{
    type: "address",
    name: "sender",
    indexed: true
  }, {
    type: "uint256",
    name: "transactionId",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Submission",
  inputs: [{
    type: "uint256",
    name: "transactionId",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Execution",
  inputs: [{
    type: "uint256",
    name: "transactionId",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "ExecutionFailure",
  inputs: [{
    type: "uint256",
    name: "transactionId",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "Deposit",
  inputs: [{
    type: "address",
    name: "sender",
    indexed: true
  }, {
    type: "uint256",
    name: "value",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "OwnerAddition",
  inputs: [{
    type: "address",
    name: "owner",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "OwnerRemoval",
  inputs: [{
    type: "address",
    name: "owner",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "RequirementChange",
  inputs: [{
    type: "uint256",
    name: "required",
    indexed: false
  }]
}];
var MultiSigWallet__factory = /** @class */function () {
  function MultiSigWallet__factory() {}
  MultiSigWallet__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  MultiSigWallet__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  MultiSigWallet__factory.abi = _abi;
  return MultiSigWallet__factory;
}();

export { MultiSigWallet__factory };
